import { useEffect, useState } from 'react';
import { api } from '../api.js';

export default function Contacto() {
  const [s, setS] = useState(null);
  useEffect(() => { api.settings().then(setS).catch(() => {}); }, []);
  const wa = s?.whatsapp;
  return (
    <div className="page narrow">
      <div className="page-head"><p className="kicker">Contacto</p><h1>Hablemos de tu dulce</h1></div>
      <div className="contact-grid">
        <div className="contact-card">
          <h3>Pedidos</h3>
          <p>La forma más rápida es hacer tu pedido desde la carta. Después te confirmamos por WhatsApp.</p>
          {wa && <a className="btn btn--primary" href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer">Escríbenos por WhatsApp</a>}
        </div>
        <div className="contact-card">
          <h3>Datos</h3>
          {s?.telefono && <p>📞 <a href={`tel:${s.telefono.replace(/\s+/g, '')}`}>{s.telefono}</a></p>}
          {s?.email && <p>✉️ <a href={`mailto:${s.email}`}>{s.email}</a></p>}
          <p>📍 Madrid · Recogida en obrador y envío a domicilio.</p>
          <p>📷 Instagram: @kanel.bakery</p>
        </div>
      </div>
    </div>
  );
}
